/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useEffect } from 'react'
import { useAppDispatch } from 'app/hooks'
import { WidgetGuard } from 'features/types'
import { Dashboard } from 'schemas/DashboardSchema'
import { useDashboardData, useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { getWidgetForDashboard } from 'features/widget/asyncThunks'
import { toFilter } from 'utils/widgetUtil'
import { SocialWebPopularPostsWidget } from 'schemas/SocialWebPopularPostsWidgetSchema'
import { createTopSearch } from 'utils/runSearchUtil'
import { ServiceType } from 'enums'
import { RunSearch } from 'schemas/action/RunSearchSchema'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'

import { getSortByOption } from './utils'
import { WidgetLoadingGuard } from '../share/guards'

const RunSearchEffect: WidgetGuard = ({ widgetId, children }) => {
  useRunSearch(widgetId)
  return <WidgetLoadingGuard widgetId={widgetId}>{children}</WidgetLoadingGuard>
}
export default RunSearchEffect

const useRunSearch = (widgetId: number) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebPopularPostsWidget>(widgetId)
  const { id: dashboardId, name } = useDashboardData() as Required<Dashboard>
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp(widgetId)

  useEffect(() => {
    const searches = createSearches(widgetSetting, dashboardId, name)
    dispatch(
      getWidgetForDashboard({
        searches,
        widgetId: widgetSetting.widgetId!,
        timestamp: refreshTimestamp
      })
    )
  }, [widgetSetting, dashboardId, name, dispatch, refreshTimestamp])
}

const createSearches = (
  widgetSetting: SocialWebPopularPostsWidget,
  dashboardId: number,
  dashboardName: string
): RunSearch[] => {
  const filter = toFilter(widgetSetting)
  const sortBy = getSortByOption(widgetSetting.viewOption)

  return [
    createTopSearch(
      dashboardId,
      dashboardName,
      widgetSetting.precision!,
      [widgetSetting.selectedTopic.topicId!],
      filter,
      widgetSetting.topN!,
      sortBy,
      ServiceType.SW_TOP_POST
    )
  ]
}
